<template>
    <div style="margin: 20px 0px">
        <avue-crud :data="data" :option="option" @selection-change="selectionChange" @size-change="sizeChange"
                   :page.sync="page" @current-change="currentChange" @search-change="searchChange"
                   @search-reset="resetChange">
            <!--            操作栏按钮-->
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item class="pull-down" @click.native="details(scope.row)">案件详情</el-dropdown-item>
                <el-dropdown-item class="pull-down" @click.native="defense(scope.row)">上传答辩证据</el-dropdown-item>
            </template>
            <template slot="case_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.case_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.case_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="zhcai_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.zhcai_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.zhcai_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="user_name" slot-scope="scope" >
                <el-tooltip :content="scope.row.user_name" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.user_name }}</p>
                </el-tooltip>
            </template>
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="signers_txt" slot-scope="scope" >
                <el-tooltip :content="scope.row.signers_txt" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.signers_txt }}</p>
                </el-tooltip>
            </template>
            <template slot="tijiao_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.tijiao_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.tijiao_time }}</p>
                </el-tooltip>
            </template>
            <template slot="lian_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.lian_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.lian_time }}</p>
                </el-tooltip>
            </template>
            <template slot="jie_an_time" slot-scope="scope" >
                <el-tooltip :content="scope.row.jie_an_time" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.jie_an_time }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
    </div>
</template>

<script>
    import { arbitrationList, caseSearch } from '../../../api/arbitrationCase';

    export default {
        name: 'petitionedCase',
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10
                },
                doc_title: '',  //合同名称
                signers_txt: '', //被申请人
                lawyer_name: '', //代理人
                data: [],
                pages: 1,
                option: {
                    menuType: 'menu',
                    menuBtnTitle: '操作',
                    selection: true, //批量选择
                    stripe: true,
                    addBtn: false,  //新增按钮
                    align: 'center',  //文本居中
                    menuAlign: 'center', //操作栏居中
                    columnBtn: false,  //列动态显隐按钮
                    refreshBtn: false,  //刷新按钮
                    editBtn: false,  //编辑按钮
                    delBtn: false,  //删除按钮
                    menuWidth: 150,  //操作栏宽度设置
                    column: [
                        {
                            label: '案件编号',
                            prop: 'case_sn'
                        },
                        {
                            label: '仲裁方式',
                            prop: 'zhcai_type'
                        },
                        {
                            label: '仲裁案号',
                            prop: 'zhcai_sn'
                        }, {
                            label: '申请人',
                            prop: 'user_name'
                        }, {
                            label: '合同名称',
                            prop: 'doc_title'
                        }, {
                            label: '合同类型',
                            prop: 'product_name'
                        }, {
                            label: '被申请人',
                            prop: 'signers_txt'
                        }, {
                            label: '案件状态',
                            prop: 'status_txt'
                        }, {
                            label: '提交案件时间',
                            prop: 'tijiao_time'
                        }, {
                            label: '立案时间',
                            prop: 'lian_time'
                        }, {
                            label: '结案时间',
                            prop: 'jie_an_time'
                        }
                    ]
                }
            };
        },
        methods: {
            //批量
            selectionChange(list) {
            },
            //分页
            currentChange(num) {
                if (this.doc_title == '' && this.signers_txt == '' && this.lawyer_name == '') {
                    arbitrationList(1, 10, num).then(res => {
                        if (res.code == 200) {
                            sessionStorage.setItem('petitionedCase', num);
                            this.data = res.data.list;
                            this.page.total = res.data.count;
                        }
                    });
                } else {
                    //    搜索后分页
                    caseSearch(this.doc_title, this.signers_txt, this.lawyer_name, 1, num).then(res => {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;

                    });
                }
            },
            //搜索
            searchChange(params, done) {
                caseSearch(params.doc_title, params.signers_txt, params.lawyer_name, 1, 1).then(res => {
                    this.doc_title = params.doc_title;
                    this.signers_txt = params.signers_txt;
                    this.lawyer_name = params.lawyer_name;
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
                done();
            },
            //重置搜索
            resetChange() {
                arbitrationList(1, 10, this.pages).then(res => {
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;
                    }
                });
            },
            details(row) {
                this.$router.push({ path: '/dealWith', query: { id: row.id } });
            },
            //上传答辩证据
            defense(row) {
                this.$router.push({ path: '/defenseEvidence', query: { id: row.id } });
            },
            //换页
            sizeChange(val) {
                arbitrationList(1, val, 1).then(res => {
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;
                    }
                });
            }
        },
        created() {
            // this.resetChange()
            if (sessionStorage.getItem('petitionedCase') === null) {
                arbitrationList(1, 10, this.pages).then(res => {
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = 1;
                    }
                });
            } else {
                arbitrationList(1, 10, sessionStorage.getItem('petitionedCase')).then(res => {
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = sessionStorage.getItem('petitionedCase');
                    }
                });
            }

        }
    };
</script>

<style scoped>
    .customize {
        background-color: #1d63f5;
        color: #fff;
    }

    /deep/ .el-table__fixed-right {
        height: 100% !important;
    }

    /deep/ .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }

    /deep/ .el-icon-arrow-down {
        font-size: 15px;
    }

    .pull-down {
        padding: 5px 30px !important;
    }
    ::v-deep .avue-crud__menu{
        min-height: 0px;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
</style>
